<script setup lang="ts">
const { copyToClipboard } = useDOM()
const { t } = useI18n()

withDefaults(
  defineProps<{
    link: string
    showIcon?: boolean
    text?: string
  }>(),
  {
    showIcon: true,
    text: 'ui.copyLink.copy'
  }
)
</script>

<template>
  <InputGroup
    class="h-10 bg-white has-[[data-slot=input-group-control]:focus-visible]:border-input has-[[data-slot=input-group-control]:focus-visible]:ring-0"
  >
    <InputGroupInput :model-value="link" readonly tabindex="-1" />
    <InputGroupAddon align="inline-end">
      <InputGroupButton
        size="sm"
        class="text-primary hover:bg-primary/5 hover:text-primary"
        @click="copyToClipboard(link)"
      >
        <BaseIcon v-if="showIcon" name="HeroLinkIconOutline" class="h-4 w-4" />
        <span class="hidden sm:flex">{{ t(text) }}</span>
      </InputGroupButton>
    </InputGroupAddon>
  </InputGroup>
</template>
